var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"popup-modal"},[_c('div',{staticClass:"window",class:_vm.size},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }